export default __webpack_public_path__ + "static/media/locate.c0e86f77.svg";